import { createPalette } from '@/util/colors';

/* eslint-disable */
const theme = {
  colors: {
    brand: {
      main: '#0276FF',
      light: '#479BFF',
      off: '#847CD0',
      pale: '#EDECF8',
      background: '#F7F6FB',
      bright: '#4B4BDE',
      white: '#FFFFFF',
    },
    failed: {
      10: '#A10000',
      20: '#CC2E2E',
      30: '#D75C5C',
      40: '#FFF3F3',
    },
    success: {
      10: '#188F32',
      20: '#00D67D',
      30: '#29EB7F',
      40: '#DEFFE5',
    },
    pending: {
      10: '#F8B700',
      20: '#FFC82C',
      30: '#FFD55F',
      40: '#FFE499',
      50: '#FFFADE',
    },
    nude: {
      pa: '#F8E1BA',
      light: '#F9E7C7',
      pale: '#FDF5E8',
    },
    primary: {
      10: '#9DA8B6',
      20: '#C0CCDA',
      30: '#D3DCE6',
      40: '#E0E6ED',
      50: '#E5E9F2',
      60: '#EFF2F7',
      70: '#F9FAFC',
    },
    text: {
      10: '#323643',
      20: '#444854',
      30: '#575A65',
    },
  },
  screens: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1440px',
  },
  fontSizes: {
    subtext: '13px',
    body: {
      large: '17px',
      2: '15px',
    },
    heading: {
      1: '48px',
      2: '40px',
      3: '32px',
      4: '20px',
    },
  },
};
export default {
  mounted() {
    const {
      colors,
      fontSizes: defaultFontSizes,
      screens: defaultScreenSizes,
      roundness: defaultRoundness,
    } = theme;

    const vm = this;

    const palette = {
      ...colors,
      ...(vm.$theme?.colors || {}),
    };
    createPalette(palette);
  },
};
